import { Link } from "react-router-dom";
import { Instagram, Send, Phone, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      toast.success("Iscrizione completata", { description: "Ti terremo aggiornato sui prossimi drop." });
      setEmail("");
    } catch {
      toast.error("Errore, riprova più tardi");
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-[#C9A227]/20 mt-20">
      {/* Newsletter */}
      <div className="max-w-7xl mx-auto px-4 py-14 border-b border-[#C9A227]/15">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <div className="eyebrow mb-2">DROP ALERTS</div>
            <h3 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight">
              Non perderti i prossimi <span className="text-[#C9A227]">drop</span>.
            </h3>
            <p className="text-[#9CA3AF] mt-3 max-w-lg">
              Ricevi in anteprima preorder, nuovi prodotti, promo e occasioni PULL STATION.
            </p>
          </div>
          <form onSubmit={submit} className="flex gap-2">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              className="flex-1 bg-black border border-[#C9A227]/30 focus:border-[#C9A227] rounded-sm px-4 py-3 text-white placeholder:text-[#6B7280] outline-none"
            />
            <button data-testid="newsletter-submit" type="submit" className="btn-gold">
              <Send size={16} /> Iscrivimi
            </button>
          </form>
        </div>
      </div>

      {/* Columns */}
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <Logo />
          <p className="text-sm text-[#9CA3AF] mt-4">
            Il punto di riferimento italiano per One Piece Card Game, Pokémon TCG, preorder e collezionismo.
          </p>
          <div className="mt-4 flex gap-2">
            <a href="#" data-testid="social-instagram" aria-label="Instagram" className="p-2 border border-[#C9A227]/30 hover:border-[#C9A227] text-[#C9A227] transition-colors rounded-sm">
              <Instagram size={16} />
            </a>
          </div>
        </div>

        <FooterCol title="PULL STATION" links={[
          { label: "Chi siamo", to: "/chi-siamo" },
          { label: "Community WhatsApp", to: "/community" },
        ]} />

        <FooterCol title="Shop" links={[
          { label: "One Piece Preorder JP", to: "/op-preorder-jp" },
          { label: "One Piece Preorder EN", to: "/op-preorder-en" },
          { label: "Carte Singole", to: "/singles" },
          { label: "Pokémon Sealed IT", to: "/pkm-sealed-it" },
          { label: "Pokémon Sealed JP", to: "/pkm-sealed-jp" },
        ]} />

        {/* Contatti */}
        <div>
          <div className="eyebrow mb-3">Contatti</div>
          <ul className="space-y-2.5">
            <li>
              <a
                href="tel:+393314250452"
                data-testid="contact-phone"
                className="flex items-center gap-2 text-sm text-white/85 hover:text-[#C9A227] transition-colors"
              >
                <Phone size={14} className="text-[#C9A227]" />
                <span className="font-mono-ps">331 425 0452</span>
              </a>
            </li>
            <li>
              <Link
                to="/community"
                data-testid="contact-community"
                className="flex items-center gap-2 text-sm text-white/85 hover:text-[#C9A227] transition-colors"
              >
                <MessageCircle size={14} className="text-[#C9A227]" />
                <span>Entra nella community</span>
              </Link>
            </li>
            <li>
              <Link
                to="/richieste"
                className="text-sm text-white/70 hover:text-[#C9A227] transition-colors"
              >
                Richieste prodotti
              </Link>
            </li>
            <li>
              <Link
                to="/spedizioni"
                className="text-sm text-white/70 hover:text-[#C9A227] transition-colors"
              >
                Spedizioni
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#C9A227]/15">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="text-xs font-mono-ps text-[#9CA3AF] tracking-[0.25em] uppercase">
            © 2026 PULL STATION — ONE PIECE • POKÉMON • TCG
          </div>
          <div className="flex items-center gap-4 text-[10px] font-mono-ps text-[#6B7280] tracking-widest uppercase">
            <Link to="/termini" data-testid="footer-terms" className="hover:text-[#C9A227] transition-colors">Termini</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#C9A227] transition-colors">Privacy Policy</Link>
            <Link to="/cookie" data-testid="footer-cookie" className="hover:text-[#C9A227] transition-colors">Cookie Policy</Link>
            <span>Bonifico • BRT • Vinted</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="eyebrow mb-3">{title}</div>
    <ul className="space-y-2">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to} className="text-sm text-white/70 hover:text-[#C9A227] transition-colors">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
